<template>
  <div>
    <div ref="userChart"></div>
  </div>
</template>

<script>
import { makeChartOptions, makeChartObj, updateChartObj } from "@/utils/charts"

export default {
  name: "UsersActions",
  props: {
    informationsUsers: {
      type: Array
    },
    user: {
      type: String
    }
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    }
  },
  data() {
    return {
      chart: null
    }
  },
  methods: {
    getChartOptions(series) {
      return makeChartOptions({
        chart: { height: 400, type: "line" },
        isThemeDark: this.isThemeDark,
        series: series,
        titleText: "Distribution actions type over time according to the user",
        tooltip: { x: { format: "dd MMM yyyy" } },
        xaxis: { type: "datetime" }
      })
    },
    getSeries() {
      const getSortedActions = data => Object.entries(data).sort()
      const userData = this.informationsUsers.find(e => e.user === this.user)
      if (userData) {
        return [
          {
            name: "Corrective",
            data: getSortedActions(userData.corrective)
          },
          {
            name: "Preventive",
            data: getSortedActions(userData.preventive)
          }
        ]
      }
      return []
    },
    makeChart() {
      const series = this.getSeries()
      const options = this.getChartOptions(series)
      this.chart = makeChartObj(this.$refs.userChart, options)
    },
    updateChart() {
      const series = this.getSeries()
      const options = this.getChartOptions(series)
      updateChartObj(this.chart, options)
    }
  },
  mounted() {
    this.makeChart()
  },
  watch: {
    isThemeDark: {
      handler(newValue) {
        this.updateChart()
      }
    },
    user: {
      handler(newValue) {
        this.updateChart()
      }
    }
  }
}
</script>
